<template>
  <data-table
    v-model="page"  
    :headers="headers" 
    :items="emails" 
    @refresh="load"
    class="elevation-1"
    :loading="loading">
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)" v-if="!item.validated"> mdi-check </v-icon>
      <v-icon small color="red" @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
    <template v-slot:no-data> </template>
  </data-table>
</template>

<script>
import EmailStrings from './EmailStrings'

export default {
  data() {
    return {
      page: 1,
      loading: true,
      headers: [
        { text: "Email", align: "start", sortable: true, value: "emailaddress" },
        { text: "label", value: "label" },
        { text: "status", value: "validated" },
        { text: "actions", value: "actions" },
      ],
      emails: []
    }
  },
  created: function () {
    this.load()
  },
  methods: {
    load() {
      this.$api.getEmailAddresses(this.username, {}, this.callBack(
        response => {
          response.forEach(item => {
            item.validated = "Pending ..."
          })
          this.emails = response
          this.$api.getEmailAddresses(this.username, { validated: true }, this.callBack(
            response => {
              response.forEach(item => {
                this.emails.forEach(email => {
                  if (item.emailaddress == email.emailaddress) email.validated = "validated"
                })
              })
            }
          ))
        }, undefined, ()=> {
          this.loading = false
        }))
    },
    editItem(item) {
      this.$router.push({ name: 'VerifyEmail', params: { label: item.label }})
    },
    deleteItem(item) {
      this.alert("confirm", EmailStrings({email: item.emailaddress}, "confirm_remove_email"), undefined, () => {
        this.$api.deleteEmailAddress(item.label, this.username, this.callBack(
          this.load
        ))
      })
    },
  },
}
</script>

<style scoped>
.v-data-table {
  width: fit-content;
  max-width: 100%;
}
</style>